import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../../../shared/pages/login/login.service';
import { PCodeServices } from '../../../../shared/services/pcode.service';

@Component({
    selector: 'reset-password-internal',
    templateUrl: './reset-password.component.html',
    standalone: false
})
export class ResetPasswordInternalComponent
{
	passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z].{8,}';

	@ViewChild('resetPasswordFormChild') resetPasswordFormChild;

	// input
	@Input() userId: string;

	// reset password form
	passwordFC = new UntypedFormControl(null, [Validators.required, Validators.pattern(this.passwordRegex)]);
	confirmPasswordFC = new UntypedFormControl(null, [Validators.required, Validators.pattern(this.passwordRegex), this.checkPasswordsValidator()]);
	public _resetPasswordForm: UntypedFormGroup = this.fb.group(
		{
			newPassword: this.passwordFC,
			confirmNewPassword: this.confirmPasswordFC
		}
	);
	get newPassword() { return this._resetPasswordForm.get('newPassword'); }
	get confirmNewPassword() { return this._resetPasswordForm.get('confirmNewPassword'); }

	// constructor
	constructor(
		private pcodeServices: PCodeServices,
		private translateService: TranslateService,
		private fb: UntypedFormBuilder,
		private loginService: LoginService
	)
	{

	}

	// reset password
	onResetPassword()
	{
		this._resetPasswordForm.markAllAsTouched();

		if (this._resetPasswordForm.valid)
		{
			this.loginService.resetPasswordInternal(this.userId, this.newPassword.value).subscribe(
				() =>
				{
					this.pcodeServices.notify('success', this.translateService.instant('Modules.Users.Applications.Users.Notifications.ResetPassword'));
					this.resetPasswordFormChild.resetForm();
				},
				error =>
				{
					// check: same password
					if (error.error.changePassword)
					{
						this.pcodeServices.notify('error', this.translateService.instant('Modules.Login.ResetPassword.Notifications.Error.SameAsCurrent'));
					}
					else
					{
						this.pcodeServices.notify('error', error.message);
					}
				}
			);
		}
	}

	// check passwords
	checkPasswordsValidator(): ValidatorFn
	{
		return () =>
		{
			if (this._resetPasswordForm)
			{
				const _password = this._resetPasswordForm.get('newPassword').value;
				const _confirmPassword = this._resetPasswordForm.get('confirmNewPassword').value;

				if (_password !== _confirmPassword)
					return { equalTo: true };
				else
					return null
			}
			else
				return null;
		}
	}
}